<template>
    <div id="loadingScreen" class="align-items-center justify-content-center d-flex">
        <LoaderCircle
                :size="50"
                :stroke-width="2"
                class="icon-rotate blue-grey-text text-darken-4"/>
    </div>
</template>

<script>

    import {LoaderCircle} from "lucide-vue-next";

    export default {
        name: 'LoadingView',
        components: {LoaderCircle},
        methods: {},
    }

</script>

<style scoped>
    #loadingScreen {
        position: absolute;
        height: 100vh;
        width: 100vw;
        background-color: white;
    }
</style>